import { Link } from "react-router-dom";
import { Box, ButtonBase } from "@mui/material";
import { alpha, useTheme } from "@mui/material/styles";
import classNames from "classnames";
import "./sideNav.css";

interface SideNavItemProps {
  active: boolean;
  disabled: boolean;
  external: boolean;
  icon?: React.ReactNode;
  path: string;
  title: string;
  hideSideNavLables?: boolean;
}

export const SideNavItem: React.FC<SideNavItemProps> = (props) => {
  const {
    active = false,
    disabled,
    external,
    icon,
    path,
    title,
    hideSideNavLables,
  } = props;

  const theme = useTheme();

  const linkProps = path
    ? external
      ? {
          component: "a",
          to: path,
          target: "_blank",
        }
      : {
          component: Link,
          to: path,
        }
    : {};

  return (
    <li>
      <ButtonBase
        sx={{
          alignItems: "center",
          display: "flex",
          justifyContent: "flex-start",
          pl: "16px",
          pr: "16px",
          py: "16px",
          textAlign: "left",
          width: "100%",
          transition: "0.2s",
          transitionTimingFunction: "ease-in-out",
          backgroundColor: active ? "#2B867C" : "#08163B",
          color: "#fff",
          "&:hover": {
            backgroundColor: "#2B867C",
          },
        }}
        {...linkProps}
      >
        {icon && (
          <Box
            component="span"
            sx={{
              alignItems: "center",
              // color: "neutral.400",
              display: "inline-flex",
              justifyContent: "center",
              mr: 2,
              // ...(active && {
              //   color: "primary.light",
              // }),
            }}
          >
            {icon}
          </Box>
        )}
        <Box
          component="span"
          className={classNames({
            hide: hideSideNavLables,
          })}
          sx={{
            // color: "neutral.400",
            flexGrow: 1,
            fontFamily: (theme) => theme.typography.fontFamily,
            fontSize: 16,
            letterSpacing: "1px",
            fontWeight: 500,
            lineHeight: "24px",
            whiteSpace: "nowrap",
            // ...(active && {
            //   color: "primary.light",
            // }),
            ...(disabled && {
              color: "neutral.500",
            }),
          }}
        >
          {title}
        </Box>
      </ButtonBase>
    </li>
  );
};
